<template>
    <div>
        <div class="row">            
            <div class="column-sidebar-left">
                <ProfileMenu v-if="isMounted" v-on:show-content="onShowContent"></ProfileMenu>
            </div>
            <div class="column-main-right">
                <ProfileHeader v-if="isMounted" :info="memberInfo" :stats="memberStats" :memberId="id"></ProfileHeader>            
                <component :is="contentComponent" v-bind="{memberID: this.id}"></component>
            </div>
        </div>        
    </div>
</template>


<script>

    import ProfileHeader from '../../components/Member/ProfileHeader.vue'
    import ProfileMenu from '../../components/Member/ProfileMenu.vue'
    import ProfileTopics from '../../components/Member/ProfileTopics.vue'
    import ProfilePosts from '../../components/Member/ProfilePosts.vue'
    import ProfileMessage from '../../components/Member/ProfileMessage.vue'
    import ProfileCAEntries from '../../components/Member/ProfileCodeArchiveEntries.vue'
    import api from '../../api/api';
    import common from '../../modules/common'

    export default {

        props: ['id'],

        data() {
            return {
                isMounted: false,
                contentComponent: ProfileTopics,
                memberInfo: null,
                memberStats: null
            }
        },
        components: {
            ProfileHeader,
            ProfileMenu,
            ProfileTopics,
            ProfilePosts,
            ProfileMessage,
            ProfileCAEntries
        },
        methods: {
            onShowContent: function(contentType) {
                switch (contentType) {
                    case 'posts': this.contentComponent = ProfilePosts; break;
                    case 'topics': this.contentComponent = ProfileTopics; break;
                    case 'message': this.contentComponent = ProfileMessage; break;
                    case 'ca-entries': this.contentComponent = ProfileCAEntries; break;
                }
            },
        },
        mounted() {        
            
            api.get('/members/profile/' + this.id)
                .then(response => { 
                    this.memberInfo = response.data.info;
                    this.memberStats = response.data.stats;     
                    
                    var bc = common.breadcrumb.create([
                        { url: '/', text: 'UtterAccess' },
                        { url: '/members/' + this.id, text: 'Members > ' +  response.data.info.displayName }
                    ]);

                    this.$store.dispatch("breadcrumb", bc);

                    this.isMounted = true;
                }
            );
        }
    }

</script>

